import React, {useState} from 'react'
import {useAuth} from '../../../../../app/modules/auth'
import CustomModal from 'app/components/CustomModal'

interface ReferralProps {
  show: boolean
  onClose: () => void
}

const Referal: React.FC<ReferralProps> = ({show, onClose}) => {
  const {currentUser} = useAuth()
  const [copySuccess, setCopySuccess] = useState<string>('')

  const copyToClipboard = () => {
    const referralId = currentUser?.uid || ''
    navigator.clipboard.writeText(referralId).then(
      () => {
        setCopySuccess('Copied!')
        setTimeout(() => setCopySuccess(''), 2000)
      },
      (err) => {
        console.error('Failed to copy: ', err)
        setCopySuccess('Failed to copy')
      }
    )
  }

  return (
    <CustomModal show={show} onClose={onClose}>
      <p className='fw-bold mb-4 fs-1 text-gray-900'>Earn $150 when you refer a friend</p>{' '}
      <p className='fs-6 fw-semibold mb-4 text-gray-900'>
        Refer a friend to SecureSlate and earn $150 credit when they sign up. Your friend will also
        get a discount!
      </p>
      <label className='fs-6 fw-semibold mb-1'>Referral Code </label>
      <div style={{display: 'flex', alignItems: 'center'}} className='mb-4 fw-block gap-1'>
        <input
          className='form-control '
          type='url'
          placeholder='Referral Id'
          style={{flexGrow: 1}}
          value={currentUser?.uid || ''}
          readOnly
        />
        <button
          className='btn btn-sm '
          style={{
            height: '42px',
            background: copySuccess ? '#E5E7EB' : '#0E9F6E',
            color: copySuccess ? '#000000' : '#ffffff',
          }}
          onClick={copyToClipboard}
        >
          {copySuccess || 'Copy'}
        </button>
      </div>
    </CustomModal>
  )
}

export default Referal
